export default __webpack_public_path__ + "static/about_hero-fda3718abc21711078efa59d9916308a.webp";